import Vue from "vue";
import { CenoraInternalCommunication } from "@cenora-llc/cenora-internal-communication-library";
import axios from "axios";

CenoraInternalCommunication.init(null, {
  emitBasicEvents: false,
  basicEventConfig: {
    axios
  },
  subscribeForBasicEvents: false,
});

class CoreInterface {
  cardDragStart(content, route, pluginPreview) {
    const message = {
      type: pluginPreview ? "plugin-card-drag-start" : "ext-card-drag-start",
      content: content,
      route,
    };
    this._postMessage(message);
  }

  cardDragEnd(position, content, route, pluginPreview) {
    const message = {
      type: pluginPreview ? "plugin-card-drag-end" : "ext-card-drag-end",
      position: position,
      content: content,
      route,
    };
    this._postMessage(message);
  }

  _postMessage({ type, ...rest }) {
    CenoraInternalCommunication.eventSender.sendMessage("message", type, rest);
  }
}

const instance = new CoreInterface();
Vue.prototype.$coreInterface = instance;
